import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/anchor-management/')({
	component: () => <Navigate to='/p/anchor-management/assortment' replace />,
})
